import { Users, Activity, TrendingUp } from "lucide-react";
import { motion } from "motion/react";
import { AnimatedCounter } from "../shared/AnimatedCounter";
import { RevealGroup, RevealItem } from "../shared/Reveal";
import { useSectionParallax } from "../../hooks/useSectionParallax";

const WIDGETS = [
  { icon: Users, label: "Generative Cohorts", accentCls: "text-[#1E4FD8] dark:text-[#4A90D9]" },
  { icon: Activity, label: "Mechanistic Models", accentCls: "text-[#5B21B6] dark:text-[#B9A5FF]" },
  { icon: TrendingUp, label: "Simulated Outcomes", accentCls: "text-[#C9A55E] dark:text-[#E0C088]" },
];

export function ProductTransition({ onDiscoverForesight }: { onDiscoverForesight?: () => void }) {
  const { ref, bgY, fgY } = useSectionParallax();
  return (
    <div ref={ref} className="py-16 bg-[#FAFAFA] dark:bg-[#050505]">
      <RevealGroup className="max-w-3xl mx-auto px-6 text-center">
        <RevealItem>
          <p className="text-xs font-bold uppercase tracking-[0.35em] text-[#1E4FD8] dark:text-[#4A90D9] mb-5">
            Understanding Data
          </p>
        </RevealItem>

        <RevealItem>
          <motion.p style={{ y: bgY }} className="text-6xl md:text-7xl font-normal tracking-[-0.03em] text-[#0A0A0F] dark:text-white">
            <AnimatedCounter target={10000} />
          </motion.p>
          <p className="text-sm font-semibold uppercase tracking-widest text-[#5C5C66] dark:text-[#9A9A9A] mt-2 mb-10">
            Virtual Patients
          </p>
        </RevealItem>

        <RevealItem>
          <motion.div style={{ y: fgY }}>
            <div className="grid grid-cols-3 gap-4 mb-10">
              {WIDGETS.map(({ icon: Icon, label, accentCls }) => (
                <div key={label} className="flex flex-col items-center gap-2 py-4 border-t border-[#0A0A0F]/10 dark:border-white/10">
                  <Icon size={18} className={accentCls} />
                  <p className="text-[11px] text-[#5C5C66] dark:text-[#9A9A9A] leading-tight">{label}</p>
                </div>
              ))}
            </div>

            <p className="text-xs font-bold uppercase tracking-[0.35em] text-[#5B21B6] dark:text-[#B9A5FF] mb-6">
              Simulating Systems
            </p>
            {onDiscoverForesight && (
              <button
                onClick={onDiscoverForesight}
                className="text-sm font-medium text-[#0A0A0F] dark:text-white border-b border-[#0A0A0F]/30 dark:border-white/30 hover:border-[#5B21B6] dark:hover:border-[#7C4DFF] transition-colors"
              >
                See how Foresight simulates it →
              </button>
            )}
          </motion.div>
        </RevealItem>
      </RevealGroup>
    </div>
  );
}
